<div *ngIf="!ltiRegistration && errorMessage">
  <div class="login">
    <div class="container-fluid h-100 no-gutters">
      <div class="row h-100">
        <div class="col-12 col-md-5 p-5">
          <img src="img/combined-shape.svg" />
          <div class="h1-eq">Customer Value Challenge</div>
          <div class="h3-eq">Welcome to the MEGA Learning simulation.</div>

          <div class="h3-eq" style="color: red; font-weight: 600">
            {{ errorMessage }}
          </div>

          <div class="h3-eq">Please come back later !</div>

          <div id="powered">
            <a href="http://megalearning.com/" target="_blank">
              <span id="powered-text">POWERED BY&nbsp;&nbsp;&nbsp;</span>
              <img src="img/mega-light.svg" alt="MEGA Learning" />
            </a>
          </div>
        </div>
        <div class="col-md-7 right-col d-none d-md-block">&nbsp;</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="ltiRegistration">
  <div class="login">
    <div class="container-fluid h-100 no-gutters">
      <div class="row h-100">
        <div class="col-12 col-md-5 p-5" style="line-height: 1.2">
          <img src="img/combined-shape.svg" />
          <div class="h1-eq">Customer Value Challenge</div>
          <div class="h3-eq">
            Welcome to the MEGA Learning simulation,
            {{ ltiRegistration.userName }}
          </div>

          <div class="h3-eq">{{ ltiRegistration.message }}</div>

          <br />
          <br />
          Context: {{ ltiRegistration.contextTitle }}<br />
          Resource: {{ ltiRegistration.resourceTitle }}<br /><br />

          <div class="h3-eq">
            Please come back when your instructor starts a simulation !
          </div>

          <div id="powered">
            <a href="http://megalearning.com/" target="_blank">
              <span id="powered-text">POWERED BY&nbsp;&nbsp;&nbsp;</span>
              <img src="img/mega-light.svg" alt="MEGA Learning" />
            </a>
          </div>
        </div>
        <div class="col-md-7 right-col d-none d-md-block">&nbsp;</div>
      </div>
    </div>
  </div>
</div>
